export default __webpack_public_path__ + "locales/ar-SA/PeopleTranslations.json?hash=ef3452f2969a84f6cf80b7ea9db412b2";